// extracted by mini-css-extract-plugin
export default {"container":"ForYouModule_container__fcrfu","headerContainer":"ForYouModule_headerContainer__QHmDu","buttonContainer":"ForYouModule_buttonContainer__KVyBa"};